module.exports = __webpack_public_path__ + "static/fonts/NotoSansKR-DemiLight-Hestia.3bc877e.otf";